export default "__VITE_ASSET__CF3t0oPN__"